import React from 'react';
import { Link } from 'react-router-dom';

const PUB = process.env.PUBLIC_URL;

function Hero() {
  return (
    <section className="hero" id="top">
      <div className="container hero__grid">
        <div>
          <span className="hero__eyebrow">Big Flats &middot; 2nd District, Chemung County Legislature</span>
          <h1 className="hero__title">
            Honest leadership.
            <span>Real results.</span>
          </h1>
          <p className="hero__subtitle">
            Ron Johanson is running for the 2nd District seat on the Chemung
            County Legislature &mdash; putting the people of Big Flats first,
            listening to them, and bringing transparency, common sense, and
            small-business discipline to county government.
          </p>
          <div className="hero__cta">
            <Link to="/contact" className="btn btn--primary">Join the Campaign</Link>
            <Link to="/about" className="btn btn--ghost">Meet Ron</Link>
          </div>
        </div>
        <figure className="hero__video-wrap">
          <video
            className="hero__video"
            poster={`${PUB}/media/campaign-poster.jpg`}
            controls
            preload="metadata"
            playsInline
          >
            <source src={`${PUB}/media/campaign-video.mp4`} type="video/mp4" />
            Your browser can&rsquo;t play this video.{' '}
            <a href={`${PUB}/media/campaign-video.mp4`}>
              Download Ron&rsquo;s campaign video
            </a>{' '}
            instead.
          </video>
          <figcaption className="hero__video-caption">
            Hear it from Ron &middot; 1:26
          </figcaption>
        </figure>
      </div>
    </section>
  );
}

export default Hero;
